import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const zeplin = defineConnector({
  identifier: "zeplin",
  name: "Zeplin",
  tagLine: "Design-to-development handoff",
  logo,
  protocol: "http",
  tags: ["productivity", "documents"],
  defaultUrlPattern: () => "https://api\\.zeplin\\.dev/.*",
  auth: (app) => bearerAuth(app.secret.personalAccessToken),
  steps: [
    {
      title: "Create a Zeplin personal access token",
      items: [
        {
          kind: "markdown",
          content:
            "Open Zeplin’s API documentation, sign in, and create a personal access token from the authentication page.",
        },
      ],
    },
    {
      title: "Enter your personal access token",
      items: [
        {
          kind: "input",
          label: "Personal access token",
          required: true,
          target: { kind: "secrets", field: "personalAccessToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => ({
      url: "https://api.zeplin.dev/v1/users/me/notifications",
      expectedStatus: [200, 403],
    }),
  },
});
